import { render } from "./dummy_carousel.vue?vue&type=template&id=eb19e278&scoped=true"
import script from "./dummy_carousel.vue?vue&type=script&lang=js"
export * from "./dummy_carousel.vue?vue&type=script&lang=js"

import "./dummy_carousel.vue?vue&type=style&index=0&id=eb19e278&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb19e278"]])

export default __exports__